import React from 'react';
import {observer} from 'mobx-react';

class LogItem extends React.Component {
    render() {
        return(<div>log item</div>)
    }
}

export default observer(LogItem);